import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-route-preloader',
  templateUrl: './route-preloader.component.html',
  styleUrls: ['./route-preloader.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RoutePreloaderComponent {
}
